var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 50,
    viewBox: "0 0 55 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 19,
    fill: "#FAB005"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4821 23.6429L27.6518 24.1875L29.3929 23.6696V22.4554C29.3929 20.3929 27.6518 18.7411 25.5714 18.7411C23.5 18.7411 21.75 20.3839 21.75 22.4286V27.9643C21.75 28.4732 21.3393 28.875 20.8393 28.875C20.3393 28.875 19.9286 28.4732 19.9286 27.9643V25.625H17C17 27.9732 17 28 17 28C17 30.1161 18.7143 31.8304 20.8304 31.8304C22.9286 31.8304 24.6607 30.1429 24.6607 28.0536V22.5893C24.6607 22.0893 25.0714 21.6786 25.5714 21.6786C26.0714 21.6786 26.4821 22.0893 26.4821 22.5893V23.6429ZM31.2143 25.625V28.0804C31.2143 28.5804 30.8036 28.9821 30.3036 28.9821C29.8036 28.9821 29.3929 28.5804 29.3929 28.0804V25.6696L27.6518 26.1875L26.4821 25.6429V28.0357C26.4821 30.1339 28.2054 31.8304 30.3125 31.8304C32.4286 31.8304 34.1429 30.1161 34.1429 28C34.1429 28 34.1429 27.9732 34.1429 25.625H31.2143Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.c38d6279e584c4ecfb01e65283ff18f6.svg";
export { ForwardRef as ReactComponent };